  <template>
  <div class="right">
    <div class="mainTop">
      <div class="underHeader">
        <img src="../../assets/img/info.png" alt />
        当前位置：
      </div>
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        style="width:50%;height: 54px;display: inline-block;line-height: 54px;"
      >
        <el-breadcrumb-item :to="{ path: '/' }">平台首页</el-breadcrumb-item>
        <el-breadcrumb-item>政府采购</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 切换 -->
    <div class="rightTab">
      <div class="tab" :class="{active:nowIndex==0}" @click="titleTab(0)">可视化概览</div>
      <div class="tab" :class="{active:nowIndex==1}" @click="titleTab(1)">数据列表</div>
    </div>
    <!-- 可视化 -->
    <tenEchart v-show="nowIndex===0" :initEchart="collapse"></tenEchart>
    <!-- 数据列表 -->
    <div class="dataList" v-show="nowIndex===1">
      <!-- 查询 -->
      <div class="rightTop">
        <div class="title">
          <img src="@/assets/img/14.png" alt />
          <span>筛选条件</span>
        </div>
        <div class="con">
          <div class="conLeft">
            <span>项目类型：</span>
            <el-radio-group v-model="params.category">
              <el-radio :label="''">全部项目</el-radio>
              <el-radio :label="'zygg'">中央项目</el-radio>
              <el-radio :label="'dfgg'">地方项目</el-radio>
            </el-radio-group>
          </div>
          <div class="conLeft1">
            <div class="selectBox">
              <span>地区：</span>
              <el-cascader
                ref="casereason"
                collapse-tags
                v-model="params.region_id"
                :options="region"
                :show-all-levels="false"
                :props="casereason_props"
                @change="casereasonChange"
              ></el-cascader>
            </div>
            <div class="selectBox">
              <span>品目：</span>
              <el-cascader
                ref="casereason_new"
                collapse-tags
                v-model="baseInfo_casereason_new"
                :options="casereasonData_new"
                :show-all-levels="false"
                :props="casereason_props_new"
                @change="casereasonChange_new"
              ></el-cascader>
            </div>
            <!-- <div class="selectBox">
              <span>交易阶段：</span>
              <el-select v-model="params.baseInfo_docType" placeholder="请选择">
                <el-option v-for="(item,i) in docTypeData" :key="i" :label="item" :value="item"></el-option>
              </el-select>
            </div>-->
          </div>
          <div class="conLeft1">
            <div class="selectBox">
              <span>采购单位：</span>
              <el-input placeholder="请输入" v-model="params.purchaser" clearable></el-input>
            </div>
            <div class="selectBox two">
              <span>代理机构：</span>
              <el-input placeholder="请输入" v-model="params.agency" clearable></el-input>
            </div>
            <div class="selectBox three">
              <span>中标供应商：</span>
              <el-input placeholder="请输入" v-model="params.entname" clearable></el-input>
            </div>
          </div>
          <div class="conLeft1">
            <div class="selectBox">
              <span>项目名称：</span>
              <el-input placeholder="请输入" v-model="params.pro_name" clearable></el-input>
            </div>
            <div class="selectBox">
              <div class="button" @click="searchFun">查询</div>
            </div>
          </div>
        </div>
      </div>
      <!--下载 -->
      <div class="rightCenter">
        <div class="centerTit"></div>
        <div class="centerCon">
          <div class="no">
            <span></span>
          </div>
          <div class="cueWords" v-show="hint">最多下载1000条</div>
          <div class="excel" @click="downloadTable()" @mouseenter="enter()" @mouseleave="leave()">
            <img src="@/assets/img/Excel.png" alt />
            下载数据到Excel
          </div>
        </div>
      </div>
      <!-- 表格 -->
      <div class="rightBottom">
        <div class="tabulationBottom">
          <el-table
            :data="majorList"
            style="width: 100% background:#052B4F;"
            border
            size="mini"
            :fit="true"
            :cell-style="cellStyle1"
            @row-click="getDetails1"
          >
            <af-table-column
              v-for="(item,index) in headerData"
              :prop="index"
              :fixed="index == 0 ? true : false "
              :label="item"
              :key="index"
              v-if="item!='中标供应商'"
            ></af-table-column>

            <af-table-column label="中标供应商" prop="entnames_entids" width="250">
              <template slot-scope="scope">
                <div>
                  <span
                    v-if="scope.row.entnames_entids"
                    v-for="(v,i) in String(scope.row.entnames_entids).split(',')"
                    :key="i"
                    :class="v.split('-')[1]!='null'?'scope_p':''"
                    @click="toEnterprisesDetail(scope,v)"
                  >{{v.split('-')[0]}}</span>
                  <!-- <span v-if="!scope.row.entnames_entids">无</span> -->
                </div>
              </template>
            </af-table-column>

            <af-table-column label="招标公告原文" width="110" prop="content_id_zb">
              <template>
                <div>
                  <el-button type="primary" size="mini">招标公告</el-button>
                </div>
              </template>
            </af-table-column>

            <af-table-column label="中标公告原文" width="110" prop="content_id">
              <template>
                <div>
                  <el-button type="success" size="mini">中标公告</el-button>
                </div>
              </template>
            </af-table-column>
          </el-table>
        </div>
      </div>
      <!-- 分页 -->
      <div class="rightPaging" style="display:flex;align-item:center;">
        <div
          style="    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
      color: #BAC7D5;
      height:32px;
       line-height: 32px;"
        >共 {{totlalCount}} 条</div>
        <el-pagination
          prev-text="上一页"
          next-text="下一页"
          background
          @current-change="handleCurrentChange"
          :current-page="params.offset"
          :page-size="params.limit"
          layout=" prev, pager, next, jumper"
          :total="1000"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import api from "@/../static/common/api/api.js";
window.api = api;
import magic from "@/../static/common/magic.js";
import axios from "axios";
import tenEchart from "@/components/tenEchart.vue";

export default {
  props: ["collapse"],
  components: {
    tenEchart
  },
  data() {
    let _self = this;
    return {
      nowIndex: 0,
      initEchart: false,
      radio: 1, //单选
      typeOnes: "",
      typeTwos: "",
      productNames: "",
      department: "",
      totlalCount: 0, //总条数
      docTypeData: [], //文书类型
      region: [], //地区数据
      casereasonData2: [], //地区二级数据
      baseInfo_casereason: [], //地区
      casereasonData_new: [], //品目数据
      casereasonData2_new: [], //品目二级数据
      baseInfo_casereason_new: [], //品目
      params: {
        offset: 1,
        limit: 10,
        category: "" //项目类型，全部项目是'',中央项目是zygg，地方项目是dfgg
      },
      majorList: [],
      headerData: [],
      // 下载提示
      hint: false,
      //地区二级数据加载
      casereason_props: {
        //案由props配置
        // lazy: true,
        // checkStrictly:true,
        multiple: true,
        children: "childrenList",
        value: "region_id",
        label: "regin_name"
        // lazyLoad(node, resolve) {
        //   const level = node.level;
        //   const id = node.value;
        //   api.getNextRegionData(id).then(res => {
        //     let _casereason = res.data;
        //     // let node = _self.changeBool(_self, _casereason, "leaf");
        //     let node =_casereason;
        //     for (let i = 0; i < _casereason.length; i++) {
        //       _self.casereasonData2.push(_casereason[i]);
        //     }
        //     resolve(_casereason);
        //   });
        // }
      },
      //品目二级数据加载
      casereason_props_new: {
        //案由props配置
        // lazy: true,
        checkStrictly: true,
        children: "childrenList",
        value: "item_id",
        label: "item_name"
        // lazyLoad(node, resolve) {
        //   const level = node.level;
        //   const id = node.value;
        //   api.cpws_getNextCasereason(id).then(res => {
        //     let _casereason = res.data;
        //     let node = _self.changeBool(_self, _casereason, "leaf");
        //     for (let i = 0; i < _casereason.length; i++) {
        //       _self.casereasonData2_new.push(_casereason[i]);
        //     }
        //     resolve(_casereason);
        //   });
        // }
      },
      selectedData: [] //选中数据
    };
  },
  computed: {},
  methods: {
    toEnterprisesDetail(scoped, names) {
      var baseInfo_caselitigant = String(scoped.row.entnames_entids);
      baseInfo_caselitigant.split(",").forEach((v, i) => {
        var name = v.split("-")[0];
        var id = v.split("-")[1];
        if (names.split("-")[0] == name) {
          var params = {
            entId: id
          };
          if (id != "null") {
            api.checkExistBussiness(params).then(res => {
              if (res.data) {
                this.$router.push({
                  path: "/enterprisesDetail",
                  query: { entId: id }
                });
              }
            });
          } else {
            this.$message.error("暂无数据!");
          }
        }
      });
    },
    // 首次展示
    firstShow() {
      let nowIndex1 = JSON.parse(sessionStorage.getItem("nowIndex"))
        ? JSON.parse(sessionStorage.getItem("nowIndex"))
        : 0;
      this.nowIndex = nowIndex1;
    },
    // 切换
    titleTab(val) {
      this.nowIndex = val;
    },
    //将leaf里的字符串类型转成bool类型
    changeBool(_this, arr, val) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].childrenList.length) {
          _this.changeBool(arr[i].childrenList, val);
        } else {
          if (arr[i].hasOwnProperty(val)) {
            arr[i][val] = arr[i][val] == "false" ? "" : true;
          }
        }
      }
      return arr;
    },
    //地区事件
    casereasonChange(values) {
      // this.params.region_id = this.$refs["casereason" ]
      //   .getCheckedNodes()[0]
      //   .pathLabels.pop();
      var arrs = [];
      var parent = [];
      values.forEach((v, i) => {
        arrs.push(v[v.length - 1]);
        parent.push(v[0]);
      });
      parent = Array.from(new Set(parent));
      arrs = Array.from(new Set(arrs));
      if (values == undefined) return;
      let value = values[values.length - 1];
      let obj = {
        type: "城市",
        types: "region_id",
        show: true
      };
      obj.label =
        this.$refs["casereason"].getCheckedNodes().length > 0
          ? this.$refs["casereason"].getCheckedNodes()[0].label + "..."
          : "";
      if (parent.length > 1) {
        // 清空级联选择器选中状态
        this.$message.error("只能选择一项地区！");
        this.params.region_id = [];
        this.$refs["casereason"].activePath = [];
        for (let i = 0; i < this.selectedData.length; i += 1) {
          if (this.selectedData[i].type === obj.type) {
            this.selectedData.splice(this.selectedData[i], 1);
            return;
          }
        }
      }
      if (!this.$refs["casereason"].getCheckedNodes()[0]) {
        for (let i = 0; i < this.selectedData.length; i += 1) {
          if (this.selectedData[i].type === obj.type) {
            this.selectedData.splice(this.selectedData[i], 1);
            return;
          }
        }
      }
      for (let i = 0; i < this.selectedData.length; i += 1) {
        if (this.selectedData[i].type === obj.type) {
          this.selectedData[i].label = obj.label;
          return;
        }
      }
      this.selectedData.unshift(obj);
      if (this.params.region_id.length != 0) {
        let arr = this.$refs["casereason"].getCheckedNodes()[0].pathLabels;
        this.params.region_name = arr.pop();
      }
    },
    //类目事件
    casereasonChange_new(values) {
      this.params.item_id = this.$refs["casereason_new"]
        .getCheckedNodes()[0]
        .pathLabels.pop();
    },
    //时间处理
    getTime(dt) {
      var year = dt.getFullYear(); //年
      var month = dt.getMonth() + 1; //月
      var date = dt.getDate(); //日
      month = month < 10 ? "0" + month : month;
      date = date < 10 ? "0" + date : date;
      var str = year + "-" + month + "-" + date;
      return str;
    },
    //筛选条件获取
    getQueryData() {
      let _this = this;
      api.cpws_getQueryData().then(res => {
        // this.docTypeData = res.data.docType;
        // this.casereasonData = _this.changeBool(_this, res.data.region, "leaf");
        // this.casereasonData_new = _this.changeBool(
        //   _this,
        //   res.data.items,
        //   "leaf"
        // );
        this.region = res.data.region;
        this.casereasonData_new = res.data.items;
        // this.casereasonData = res.data.casereason;
      });
    },

    searchFun() {
      let _this = this;
      magic.loginOrRights(0).then(res => {
        if (!res) {
          _this.$message.error("请您登录！");
          return;
        }
        if (res && res.rights == 0) {
          _this.$message.error("您没有权限！");
          return;
        }
        _this.getWenshuSearchData();
        // 埋点
        try {
          //LogCollection.contents["key"]="value";
          //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
          //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
          LogCollection.send(9);
        } catch (e) {}
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.params.offset = val;
      this.getWenshuSearchData();
    },
    // 表格数据
    getWenshuSearchData() {
      //为地区数据进行转化，数组去重并去掉父级id转成字符串传出
      if (this.params.region_id) {
        this.params.region_id = [
          ...new Set([].concat.apply([], this.params.region_id))
        ];
        this.params.region_id = this.params.region_id.splice(1).join(",");
      }
      // 点击查询
      api.cpws_getWenshuSearchData(this.params).then(res => {
        this.totlalCount = res.data.total;
        this.majorList = res.data.rows;
        this.headerData = res.data.colums;
      });
    },
    // 公司高亮
    cellStyle1({ row, column, rowIndex, columnIndex }) {
      // if (columnIndex === 0 || columnIndex === 2) {
      //   return `color:#3583ED;font-weight:bold;cursor: pointer;`;
      // } else {
      //   return "";
      // }
      return "";
    },
    // 去搜索页
    getDetails1(row, column, val) {
      let _this = this;
      magic.loginOrRights(2625).then(res => {
        if (!res) {
          _this.$message.error("请您登录！");
          return;
        }
        if (res && res.rights == 0) {
          _this.$message.error("您没有权限！");
          return;
        }
        if (column.label == "招标公告原文") {
          // this.$router.push({ name: "tenderdetail", params: {id: row.content_id_zb,type: 'content_id_zb'} });
          if (row.content_id_zb) {
            api.cpws_ifWenshuDetail_has(row.content_id_zb).then(res => {
              if (res.data.flag == true) {
                let routeData = this.$router.resolve({
                  name: "tenderdetail",
                  query: {
                    id: row.content_id_zb
                  }
                });
                window.open(routeData.href, "_blank");
              } else {
                this.$message.error("暂无数据！");
              }
            });
          } else {
            this.$message.error("暂无数据！");
          }
        }
        if (column.label == "中标公告原文") {
          // this.$router.push({ name: "tenderdetail", params: {id: row.content_id,type: 'content_id'} });

          if (row.content_id) {
            api.cpws_ifWenshuDetail_has(row.content_id).then(res => {
              if (res.data.flag == true) {
                let routeData = this.$router.resolve({
                  name: "tenderdetail",
                  query: {
                    id: row.content_id
                  }
                });
                window.open(routeData.href, "_blank");
              } else {
                this.$message.error("暂无数据！");
              }
            });
          } else {
            this.$message.error("暂无数据！");
          }
        }
        // 埋点
        try {
          //LogCollection.contents["key"]="value";
          //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
          //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
          LogCollection.send(9);
        } catch (e) {}
      });
    },
    // 下载
    enter() {
      this.hint = true;
    },
    leave() {
      this.hint = false;
    },
    downloadTable() {
      axios({
        method: "post",
        url: window.normalUrl + "/zfcg/downWenshuData", // 请求地址
        data: this.params,
        responseType: "arraybuffer",
        observe: "response"
      }).then(res => {
        const fileName = "政府采购.xlsx";
        let blob = new Blob([res.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏
        //3：下载
        //4：分享
        //5：购买
        //6：登录
        //7：注册
        //9：搜索
        //10：复制
        //11：点赞
        //12：评论
        LogCollection.send(3);
      } catch (e) {}
    },
    download(data) {
      if (!data) {
        return;
      }
      let url = window.URL.createObjectURL(new Blob([data]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", "excel.xlsx");
      document.body.appendChild(link);
      link.click();
    }
  },
  created() {},
  mounted() {
    this.firstShow(); //首次展示
    this.getWenshuSearchData();
    this.getQueryData();
  }
};
</script>
<style scoped lang="less">
.scope_p {
  margin-left: 5px;
  color: #3583ed;
  font-weight: bold;
  cursor: pointer;
}
.selectBox {
  width: 30% !important;
}
.el-cascader {
  width: 332px;
}
/deep/.el-range-editor /deep/ .el-range-input {
  background: #023261;
  color: #dfecf7;
}
/deep/.el-date-editor /deep/.el-range-separator {
  color: #dfecf7;
}
@import "../../assets/less/style.less";
@import "../../assets/less/right.less";
@import "../../assets/less/moreThanThree.less";
</style>


// WEBPACK FOOTER //
// src/view/tendering/default.vue